import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldDropdownMultipleModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  options: Array<string>;
  value: string;
}

export class FieldDropdownMultipleModel extends BaseFieldModel implements IFieldDropdownMultipleModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public options: Array<string>,
    public value: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
